import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Invoice from "../components/Invoice";
import * as invoiceActions from "./../../../../actions/invoice.actions";
import * as userActions from "./../../../../actions/user.actions";

class InvoiceContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.invoiceActions.getInvoices();
  }

  render() {
    return this.props.invoices && <Invoice invoices={this.props.invoices} />;
  }
}

const mapStateToProps = state => {
  return {
    invoices: state.invoice.invoices
  };
};

const mapDispatchToProps = dispatch => {
  return {
    invoiceActions: bindActionCreators(invoiceActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/invoice/containers/InvoiceContainer.js